module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Original_Preface"
    }
  }, [_vm._v("Original Editor’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Theodore P. Savas")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_New_Preface"
    }
  }, [_vm._v("New Editor’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Theodore P. Savas")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Eric C. Rust")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter01"
    }
  }, [_vm._v("In Memoriam Engelbert Endrass: Castor Mourns Pollox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Erich Topp")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karl-Friedrich Merten and the Prussian Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Timothy P. Mulligan")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ralph Kapitsky: Battle in the Caribbean and the Death of U-615")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Gaylord T. M. Kelshall")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fritz Guggenberger: Bavarian U-Boat Ace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Eric C. Rust")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Victor Oehrn: The Ace With No Name")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Jordan Vause")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heinz-Wilhelm Eck: Siegerjustiz and the Peleus Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Dwight R. Messimer")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("*  *  *")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Bonus Material")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Editors_Preface",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Editor’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("from "), _c('i', [_vm._v("Hunt and Kill: U-505 and the U-Boat War in the Atlantic")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65287201","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 66
// module chunks = 0